export enum ControlCode {
  Up = "UP",
  Down = "DOWN",
  Left = "LEFT",
  Right = "RIGHT",

  Fire = "FIRE",

  Menu = "MENU",
  Menu1 = "MENU_1",
  Menu2 = "MENU_2",
  Menu3 = "MENU_3",
  Menu4 = "MENU_4",
  Menu5 = "MENU_5",
  Menu6 = "MENU_6",
  Menu7 = "MENU_7",
  Menu8 = "MENU_8",
  Menu9 = "MENU_9",
  Menu0 = "MENU_0",

  PlaceReflectorA = "PLACE_REFLECTOR_A",
  PlaceReflectorB = "PLACE_REFLECTOR_B",
  RemoveReflector = "REMOVE_REFLECTOR",
  ClearAllReflectors = "CLEAR_ALL_REFLECTORS",

  Rebuild = "REBUILD",
  RemoveBuilding = "REMOVE_BUILDING",
  RotateBuilding = "ROTATE_BUILDING",
  ToggleJobs = "TOGGLE_JOBS",
  Wait = "WAIT",
  QuickAction = "QUICK_ACTION",
  Back = "BACK",
  Undo = "UNDO",
  Help = "HELP",
  ZoomIn = "ZOOM_IN",
  ZoomOut = "ZOOM_OUT",
  FocusJobPriorities = "FOCUS_JOB_PRIORITIES",
  DismissNotifications = "DISMISS_NOTIFICATIONS",

  FocusTutorials = "FOCUS_TUTORIALS",
  ToggleTutorials = "TOGGLE_TUTORIALS",
  DismissTutorial = "DISMISS_TUTORIAL",
}
